import { normalizeSupergraphMeetingNode } from './utils'

const withRandomKey = (node: any) => ({
  ...normalizeSupergraphMeetingNode(node),
  key:
      typeof crypto !== 'undefined' && (crypto as any).randomUUID
        ? (crypto as any).randomUUID()
        : node?.uuid,
})

/**
   * `Meetings_ListMeetingsConnection` exposes edges on `meetings` (not `edges`). Map it to the
   * `{ meetings: { edges, pageInfo } }` shape the list orchestration consumes; tolerate a rich
   * connection that already uses `edges`.
   */
export const transformMeetingsSupergraphConnectionResponse = (response: any) => {
  const conn = response?.listMeetings
      ?? response?.meetingsPageList
      ?? response?.meetings
      ?? {}
  let rawEdges: any[] = []
  if (Array.isArray(conn.meetings)) {
    rawEdges = conn.meetings
  } else if (Array.isArray(conn.edges)) {
    rawEdges = conn.edges
  }
  const edges = rawEdges
    .filter((edge: any) => edge?.node != null)
    .map((edge: any) => ({
      ...edge,
      node: withRandomKey(edge.node),
    }))

  return {
    meetings: {
      ...conn,
      edges,
    },
  }
}
